import { useSelector } from "react-redux"
// Pages
import Home from "./pages/Home/Home"
import ProductsList from "./pages/ProductsList/ProductsList"
import Product from "./pages/Product/Product"
import Cart from "./pages/Cart/Cart"
import Register from "./pages/Register/Register"
import Login from "./pages/Login/Login"
import Account from "./pages/Account/Account"
import ThreeDView from "./pages/ThreeDView/ThreeDView"
import Order from "./pages/Order/Order"
import Search from "./pages/Search/Search"
import Contact from "./pages/Contact/Contact"
import Verify from "./pages/Verify/Verify"
import ResetPassword from "./pages/ResetPassword/ResetPassword"
import Story from "./pages/Story/Story"
import Mif from "./pages/Mif/Mif"
import NewCollection from "./pages/NewCollection/NewCollection"
import ShopFinder from "./pages/ShopFinder/ShopFinder"
import Legal from "./pages/Legal/Legal"
// Routes
import {
   BrowserRouter as Router,
   Routes,
   Route,
   Navigate,
} from "react-router-dom"
import ScrollToTop from "./helpers/ScrollToTop"
// Styles
import { GlobalStyle, lightTheme } from "./GlobalStyle"
import { ThemeProvider } from "styled-components"
import { MuiLightTheme } from "./MuiTheme"
import { ThemeProvider as MuiThemeProvider } from "@mui/material"

const App = () => {
   const user = useSelector((state) => state.user.currentUser)

   return (
      <Router>
         <ScrollToTop />
         <MuiThemeProvider theme={MuiLightTheme}>
            <ThemeProvider theme={lightTheme}>
               <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products/" element={<ProductsList />} />
                  <Route
                     path="/products/:category"
                     element={<ProductsList />}
                  />
                  <Route
                     path="/product/:productId/:variationId"
                     element={<Product />}
                  />
                  <Route path="/cart" element={<Cart />} />
                  <Route
                     path="/register"
                     element={user ? <Navigate to="/account" /> : <Register />}
                  />
                  <Route
                     path="/login"
                     element={user ? <Navigate to="/account" /> : <Login />}
                  />
                  <Route
                     path="/account"
                     element={user ? <Account /> : <Navigate to="/login" />}
                  />
                  <Route
                     path="/3Dview/:variationCode"
                     element={<ThreeDView />}
                  />
                  <Route path="/order/:orderId" element={<Order />} />
                  <Route path="/search/:searchTerm" element={<Search />} />
                  <Route path="/search" element={<ProductsList />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/verify/:userId" element={<Verify />} />
                  <Route
                     path="/resetPassword/:userId/:userEmail/:token"
                     element={<ResetPassword />}
                  />
                  <Route path="/story" element={<Story />} />
                  <Route path="/mif" element={<Mif />} />
                  <Route path="new-collection" element={<NewCollection />} />
                  <Route path="/shopfinder" element={<ShopFinder />} />
                  <Route path="/legal" element={<Legal />} />
               </Routes>
               <GlobalStyle />
            </ThemeProvider>
         </MuiThemeProvider>
      </Router>
   )
}

export default App
